import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="hero-content">
          <img src="/headshot.jpeg" className="headshot" alt="David Peterson" />
          <h1>David Peterson Consulting Inc.</h1>
          <h2>Chief Architect & CTO</h2>
          <p className="hero-text">
            Leveraging my 25 years of experience at Microsoft to deliver executive-level cloud strategy and architecture consulting.
            Specializing in cloud transformation, AI strategy, application architecture, development, and modernization.
          </p>
          <div className="hero-badge">
            <img src="/microsoft-certified-expert-badge.svg" className="certification-badge" alt="Microsoft Certified Expert" />
          </div>
          <div className="hero-contact">
            <p><strong>Phone:</strong> <a href="tel:+14164287660">(416) 428-7660</a></p>
            <p><strong>Email:</strong> <a href="mailto:david@davidpetersonconsulting.com">david@davidpetersonconsulting.com</a></p>
            <p><strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/david-peterson-64456021/" target="_blank" rel="noopener noreferrer">David Peterson</a></p>
            <p><strong>Address:</strong>Toronto, Ontario, Canada</p>
            <p><strong>Calendly:</strong> <a href="https://calendly.com/david-dpeterson/discovery">Book A Discovery Call</a> 
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16px" height="16px" style={{marginLeft: '6px', display: 'inline'}}>
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3h-7z"/>
                </svg></p>
          </div>
        </div>
      </header>

      <div className="content-column">
        <section className="services-section">
          <h3>Services</h3>
          <div className="services-grid">
            <div className="service-card">
               <div className="service-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="48px" height="48px">
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3z"/>
                </svg>
              </div>
              <h4>Cloud Architecture Strategy</h4>
              <p>Strategic guidance to design scalable, secure, and cost-optimized cloud architectures aligned to your business goals.</p>
              <a
                className="service-link"
                href="https://calendly.com/david-dpeterson/discovery"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Discovery Call
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16px" height="16px" style={{marginLeft: '6px', display: 'inline'}}>
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3h-7z"/>
                </svg>
              </a>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="48px" height="48px">
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z" opacity=".3"/> {/* Just a placeholder path, let's get real ones */}
                  <path d="M20 2H4c-1.1 0-2 .9-2 2v16l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zM12 6c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" opacity="0"/>
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM12 6c-2.41 0-4.26 1.75-4.26 4 0 1.46.78 2.73 1.96 3.43L7 18l1-1.25v.01l.02-.01L12 12l3.98 4.74.02.01v-.01l1 1.25-2.7-4.57c1.18-.7 1.96-1.97 1.96-3.43 0-2.25-1.85-4-4.26-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                </svg>
                {/* Using a better Search/Doc icon for Audit */}
              </div>
              <h4>Architecture Design / Review</h4>
              <p>Providing technical leadership by shaping architecture, guiding engineering teams, and ensuring scalable, secure, and future-ready systems.</p>
              <a
                className="service-link"
                href="https://calendly.com/david-dpeterson/discovery"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Discovery Call
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16px" height="16px" style={{marginLeft: '6px', display: 'inline'}}>
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3h-7z"/>
                </svg>
              </a>
            </div>
            <div className="service-card">
              <div className="service-icon">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="48px" height="48px">
                    <path d="M0 0h24v24H0z" fill="none"/>
                    <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
                 </svg>
              </div>
              <h4>Application Development & Modernization</h4>
              <p>Development and modernization of applications through modern cloud-native patterns and technologies.</p>
              <a
                className="service-link"
                href="https://calendly.com/david-dpeterson/discovery"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Discovery Call
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16px" height="16px" style={{marginLeft: '6px', display: 'inline'}}>
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3h-7z"/>
                </svg>
              </a>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="48px" height="48px">
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M12 3C7.03 3 3 6.58 3 11c0 2.36 1.14 4.47 3 5.95V21l3.22-1.76c.58.1 1.18.16 1.78.16 4.97 0 9-3.58 9-8s-4.03-8-9-8zm0 14c-.63 0-1.25-.07-1.85-.2l-.55-.12-.49.27L7 18.03v-2.19l-.36-.28C5.21 14.51 4 12.81 4 11c0-3.31 3.13-6 7-6s7 2.69 7 6-3.13 6-7 6zm-3-7h6v1H9v-1zm0-2h6v1H9V8zm0 4h4v1H9v-1z"/>
                </svg>
              </div>
              <h4>Architecture Coaching</h4>
              <p>1:1 coaching sessions to discuss cloud architectural approaches, tackle design questions, and validate decisions.</p>&nbsp;
              <a
                className="service-link"
                href="https://calendly.com/david-dpeterson/architecture-session"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book a Session
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="16px" height="16px" style={{marginLeft: '6px', display: 'inline'}}>
                  <path d="M0 0h24v24H0z" fill="none"/>
                  <path d="M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83l1.41 1.41L19 6.41V10h2V3h-7z"/>
                </svg>
              </a>              
            </div>
          </div>
        </section>

        <section className="about-section">
          <h3>About Me</h3>
          <div className="about-content">
            <p>
              With 25 years at Microsoft working with enterprise organizations, I’ve built my career around helping leaders navigate major shifts in cloud, AI, and application modernization. I’ve worked alongside CIOs, CTOs, architects, and engineering teams to design scalable architectures, modernize mission-critical applications, and build strategies that drive long-term innovation.
            </p>
            <p>
              Today, I bring that deep experience into my consulting practice, partnering with organizations that want senior, trusted guidance on cloud adoption, AI integration, and modern application development. I focus on cutting through complexity, aligning technology with business outcomes, and helping executive teams make confident, forward-looking decisions.
            </p>
            
            <h4>My expertise includes:</h4>
            <ul>
              <li>Executive cloud strategy, transformation planning, and modernization roadmaps</li>
              <li>AI strategy and responsible adoption for practical, real-world value</li>
              <li>Application architecture design and modernization using modern cloud-native patterns</li>
              <li>Hands-on technical leadership and guidance for engineering teams</li>
              <li>Coaching executives and architects through high-impact technology decisions</li>
            </ul>

            <p>
              I’m passionate about working with organizations that want to accelerate their cloud and AI journey while maintaining architectural clarity, operational excellence, and long-term sustainability. My approach blends strategic insight, engineering depth, and decades of experience working directly with enterprise customers at scale.
            </p>
            <p>
              If your organization is evaluating cloud strategy, planning AI initiatives, or looking for senior architectural guidance, <a href="https://calendly.com/david-dpeterson/discovery">I’d be happy to connect</a>.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;
